module.exports = __webpack_public_path__ + "static/img/contact_map.daf043b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contact_map.png
// module id = 0NTl
// module chunks = 1